import styled from "styled-components";
import React from "react";
import { BackToTop } from "discover.medical.react-component-library";

export const BackToTopWrapper = styled(({ visible, ...rest }) => (
  <BackToTop {...rest} />
))`
  height: auto;
  transform: scale(0);
  opacity: 0;
  transition: opacity 1s, transform 0s linear 1s, height 0s linear 1s;

  ${(props) =>
    props.visible &&
    `opacity: 1;
    height: auto;
    transform: scale(0.625);
    transition: height 0s, transform 0s, opacity 1s;
  `};
`;
